<template>
  <v-navigation-drawer dark absolute expand-on-hover permanent right>
    <v-list dense>
      <v-list-item @click="loadSummary('collated')">
        <v-list-item-icon>
          <v-icon>mdi-image-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Combined Moodboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Individuals</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <template v-for="doc in boards">
        <v-list-item :key="doc.id" @click="loadBoard(doc.id)">
          <v-list-item-icon>{{ getUser(doc.uid) }} </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ doc.title }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "ResultsMultipleTilesBar",
  props: {
    doc: {
      type: Object,
    },
    boards: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    filteredUsers() {
      // return this.doc ? this.doc.users.filter(item => item.webrole == 'user') : null
      return this.doc.users;
    },
  },
  methods: {
    loadUser(val) {
      this.$emit("loadUser", val);
    },
    loadSummary(val) {
      this.$emit("loadSummary", val);
    },
    loadBoard(val) {
      this.$emit("loadBoard", val);
    },
    getUser(uid) {
      const item = this.doc.users.find((x) => x.uid === uid);
      return item.initial;
    },
  },
};
</script>
